var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWarningIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 30,
    viewBox: "0 0 32 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.78169 23.4396L12.0663 2.54594C13.7197 -0.515294 18.1118 -0.51532 19.7651 2.5459L31.05 23.4396C32.6243 26.3545 30.5135 29.8937 27.2006 29.8937H4.63111C1.31822 29.8937 -0.792646 26.3546 0.78169 23.4396ZM16.0304 8.125C15.3948 8.125 14.8795 8.64028 14.8795 9.27591V16.7184C14.8795 17.3541 15.3948 17.8693 16.0304 17.8693C16.666 17.8693 17.1813 17.3541 17.1813 16.7184V9.27591C17.1813 8.64028 16.666 8.125 16.0304 8.125ZM16.0214 24.0886C17.0384 24.0886 17.8629 23.2623 17.8629 22.2431C17.8629 21.2238 17.0384 20.3976 16.0214 20.3976C15.0044 20.3976 14.1799 21.2238 14.1799 22.2431C14.1799 23.2623 15.0044 24.0886 16.0214 24.0886Z",
    fill: "#B3261E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarningIcon);
export default __webpack_public_path__ + "static/media/warning_icon.10fa4cb915d177ac929d60ce8ed48586.svg";
export { ForwardRef as ReactComponent };